//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    picture: {
      type: [String, Array],
      default: () => []
    },
    indexSelected: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      active: this.indexSelected,
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      defaultXPosition: 0,
      defaultYPosition: 0,
      down: false
    }
  },
  computed: {
    eventsListeners() {
      return {
        ...this.$listeners,
        mousedown: (e) => {
          // Начальная точка движения
          this.startX = e.clientX
          this.startY = e.clientY
          // Чтобы утрать транзишт
          this.down = true
          // Сохраняем старое расположение жлемента
          this.defaultXPosition = this.x
          this.defaultYPosition = this.y
        },
        mousemove: (e) => {
          if (this.down) {
            this.x = this.defaultXPosition + e.clientX - this.startX
            this.y = this.defaultYPosition + e.clientY - this.startY
          }
        },
        mouseup: (e) => this.handleMouseup(e),
        mouseleave: (e) => this.handleMouseup(e)
      }
    }
  },
  mounted() {
    this.centerDefinition()
  },
  methods: {
    downloadImage(url) {
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", 'image');
      link.click();
    },
    changeActive(e, i) {
      if(this.active !== i) {
        this.centerDefinition()
        this.active = i
      }
    },
    centerDefinition() {
      this.x = window.innerWidth / 2
      this.y = window.innerHeight / 2
    },
    handleMouseup(e) {
      const width = e.target.offsetWidth
      const height = e.target.offsetHeight
      this.down = false
      // Если элемент уходит на пределы экрана возващаем его
      if (this.x - width / 2 < 0) {
        this.x = width / 2
      } else if (this.x + width / 2 > window.innerWidth) {
        this.x = window.innerWidth - width / 2
      }
      if (this.y - height / 2 < 0) {
        this.y = height / 2
      } else if (this.y + height / 2 > window.innerHeight) {
        this.y = window.innerHeight - height / 2
      }
    }
  }
}
